import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthUser, parseUserRole, isFleetOwnerRole } from '@ubus/shared';
import { homePathForRole } from '../utils/homePath';

export function ForbiddenPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useAuthUser();
  const role = parseUserRole(user);
  const home = homePathForRole(role);
  const roleName = isFleetOwnerRole(role) ? t('common.roleOwner') : t('common.roleAdmin');

  return (
    <div className="admin-status-page">
      <Result
        status="403"
        title="403"
        subTitle={t('status.forbiddenSubtitle')}
        extra={
          <Button type="primary" onClick={() => navigate(home)}>
            {t('common.backHome')}
          </Button>
        }
      />
      {role ? (
        <p className="admin-status-page__meta">{t('status.signedInAs', { role: roleName })}</p>
      ) : null}
    </div>
  );
}

export default ForbiddenPage;
